import React, { Component } from 'react';
import ReactPlayer from 'react-player'; // Используем новый плеер

class Video extends Component {
  // Тот же метод-дешифратор, что и в редакторе
  renderPlayer = (url, canBeRewound) => {
    if (!url) return <p>Видео не загружено</p>;
    // 2. ОБРАБОТКА RUTUBE (ID из базы rt_... или прямая ссылка)
    if (url.indexOf('rt_') === 0 || url.indexOf('rutube.ru') !== -1) {
      var videoId = url.indexOf('rt_') === 0 ? url.replace('rt_', '') : url.split('/').filter(Boolean).pop().split('?')[0];
      const finalUrl = `https://rutube.ru/play/embed/${videoId}/`;
      
      return (
        <iframe 
          src={finalUrl} 
          width="100%" height="100%" 
          style={{ position: 'absolute', top: 0, left: 0 }}
          frameBorder="0" allowFullScreen 
        />
      );
    }

    // 3. YouTube и другие (стандартный ReactPlayer)
    return (
      <ReactPlayer
        url={url}
        controls={canBeRewound}
        width="100%"
        height="100%"
        style={{ position: 'absolute', top: 0, left: 0 }}
      />
    );
  }

  render() {
    const { slide } = this.props;
    const videoData = slide.item || slide; 
    
    // Берем данные из youTubeVideo (где у нас лежат vk_... или rt_...)
    const url = videoData.youTubeVideo; 
    const canBeRewound = !!videoData.canBeRewound;

    return (
      <div className="videoTest">
         <div className="video__wrapper" style={{ position: 'relative', paddingTop: '56.25%', background: '#000' }}>
          {this.renderPlayer(url, canBeRewound)}
        </div>
      </div>
    );
  }
}

export default Video;